import Layout from '@/layout';
export default {
  path: '/gaokao',
  component: Layout,
  redirect: '/gaokao/batches',
  name: 'Gaokao',
  meta: {
    title: '志愿填报',
    icon: 'clipboard'
  },
  children: [{
    path: 'schools',
    component: function component() {
      return import('@/views/gaokao/catalog');
    },
    name: 'GaokaoSchools',
    props: {
      kind: 'SCHOOLS'
    },
    meta: {
      title: '大学管理'
    }
  }, {
    path: 'majors',
    component: function component() {
      return import('@/views/gaokao/catalog');
    },
    name: 'GaokaoMajors',
    props: {
      kind: 'MAJORS'
    },
    meta: {
      title: '专业管理'
    }
  }, {
    path: 'brochures',
    component: function component() {
      return import('@/views/gaokao/brochures');
    },
    name: 'GaokaoBrochures',
    meta: {
      title: '招生简章管理'
    }
  }, {
    path: 'controls',
    component: function component() {
      return import('@/views/gaokao/basicData');
    },
    name: 'GaokaoControls',
    props: {
      kind: 'CONTROLS'
    },
    meta: {
      title: '省控线管理'
    }
  }, {
    path: 'segments',
    component: function component() {
      return import('@/views/gaokao/basicData');
    },
    name: 'GaokaoSegments',
    props: {
      kind: 'SEGMENTS'
    },
    meta: {
      title: '分段表管理'
    }
  }, {
    path: 'cutoffs',
    component: function component() {
      return import('@/views/gaokao/cutoffs');
    },
    name: 'GaokaoCutoffs',
    meta: {
      title: '投档线管理'
    }
  }, {
    path: 'plans',
    component: function component() {
      return import('@/views/gaokao/plans');
    },
    name: 'GaokaoPlans',
    meta: {
      title: '招生计划管理'
    }
  }, {
    path: 'batches',
    component: function component() {
      return import('@/views/gaokao/batches');
    },
    name: 'GaokaoBatches',
    meta: {
      title: '志愿数据与发布'
    }
  }, {
    path: 'materials',
    redirect: '/gaokao/batches?tab=import'
  }, {
    path: 'scopes',
    redirect: '/gaokao/batches?tab=publish'
  }, {
    path: 'ai',
    component: function component() {
      return import('@/views/gaokao/ai');
    },
    name: 'GaokaoAi',
    meta: {
      title: 'AI辅助配置'
    }
  }, {
    path: 'records',
    component: function component() {
      return import('@/views/gaokao/records');
    },
    name: 'GaokaoRecords',
    meta: {
      title: '填报记录'
    }
  }]
};